import axios from "axios";
import { API_BASE_URL } from "../../config/apiConfig";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use((config) => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user?.token) {
    config.headers.Authorization = `Bearer ${user.token}`;
  }
  return config;
});

export const activityApi = {
  /**
   * TRACK POST VIEW
   * Endpoint: POST /api/feed/activity/view
   * Body: { postId }
   * Response: { success: true }
   */
  trackView: async (postId) => {
    try {
      return await apiClient.post("/feed/activity/view", { postId });
    } catch (error) {
      // Silent fail - don't block UI for analytics
      return { success: false };
    }
  },

  /**
   * TRACK READING TIME
   * Endpoint: POST /api/feed/activity/read-time
   * Body: { postId, seconds }
   * Response: { success: true }
   */
  trackReadingTime: async (postId, seconds) => {
    try {
      return await apiClient.post("/feed/activity/read-time", {
        postId,
        seconds,
      });
    } catch (error) {
      return { success: false };
    }
  },

  /**
   * TRACK POST SKIP (Negative Signal)
   * Endpoint: POST /api/feed/activity/skip
   * Body: { postId }
   * Response: { success: true }
   */
  trackSkip: async (postId) => {
    try {
      return await apiClient.post("/feed/activity/skip", { postId });
    } catch (error) {
      return { success: false };
    }
  },

  /**
   * TRACK ENGAGEMENT
   * Endpoint: POST /api/feed/activity/engagement
   * Body: { postId, type, value }
   * Types: 'click', 'share', 'comment', 'like'
   * Response: { success: true }
   */
  trackEngagement: async (postId, type, value = 1) => {
    try {
      return await apiClient.post("/feed/activity/engagement", {
        postId,
        type,
        value,
      });
    } catch (error) {
      return { success: false };
    }
  },

  /**
   * BATCH TRACK ACTIVITIES (Performance Optimized)
   * Endpoint: POST /api/feed/activity/batch
   * Body: {
   *   activities: [
   *     { type: 'view', postId: '123' },
   *     { type: 'read-time', postId: '456', seconds: 30 }
   *   ]
   * }
   * Response: { success: true, tracked: 2 }
   */
  batchTrack: async (activities) => {
    try {
      if (!activities || activities.length === 0) {
        return { success: true, tracked: 0 };
      }
      return await apiClient.post("/feed/activity/batch", { activities });
    } catch (error) {
      return { success: false, tracked: 0 };
    }
  },
};

export default activityApi;
